
    const data = {"name":"src/core/icons/exclamation-thick","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 3h4v11h-4V3m0 18v-4h4v4h-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            